import { defineComponent } from "vue";

export default defineComponent({
  props: {
    slides: { type: Array, required: true },
    startAt: { type: Number, default: 0 },
  },
});
